













import { Select } from '@alpha/ink'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { SelectOption } from '../../../../packages/ink/src/types/interfaces'

@Component({
  components: {
    Select
  }
})
export default class HHIBandSelect extends Vue {
  @Prop({ required: true }) readonly options!: SelectOption[]
  @Prop({ default: null }) readonly value!: SelectOption | null
  @Prop({ required: true }) readonly band!: string
  @Prop({ required: true }) readonly oppositeBand!: number

  isOptionDisabled (optionValue: number) {
    return this.band === 'min' ? (optionValue > this.oppositeBand && this.oppositeBand > 0) : (this.oppositeBand > optionValue)
  }
}
